import { topicItems } from '@/mocks/homepage';

export default function Topics() {
  return (
    <section id="topics" className="w-full py-12 md:py-16 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-2 mb-8 md:mb-10">
          <i className="ri-hashtag text-xl text-primary-500"></i>
          <h2 className="text-xl md:text-3xl font-bold text-foreground-900 font-heading">
            热门话题
          </h2>
        </div>

        <div className="flex flex-wrap gap-3">
          {topicItems.map((item) => (
            <div
              key={item.id}
              className="group flex items-center gap-3 bg-background-50 border border-background-200/60 rounded-xl px-5 py-3.5 md:px-6 md:py-4 hover:border-primary-200 hover:bg-background-100 transition-all duration-300 cursor-pointer"
            >
              <div className="flex items-center gap-2">
                {item.hot && (
                  <i className="ri-fire-line text-accent-500 text-sm animate-pulse"></i>
                )}
                <span className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors">
                  #{item.name}
                </span>
              </div>
              <span className="text-xs text-foreground-400 shrink-0">{item.count}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}